import { render, staticRenderFns } from "./item-template-v2.vue?vue&type=template&id=5771edcd&scoped=true&"
import script from "./item-template-v2.vue?vue&type=script&lang=js&"
export * from "./item-template-v2.vue?vue&type=script&lang=js&"
import style0 from "./item-template-v2.vue?vue&type=style&index=0&id=5771edcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5771edcd",
  null
  
)

export default component.exports